module.exports = __webpack_public_path__ + "static/media/background.506cd3ee.jpg";